<div class="status-container">
  <div class="confetti-container" id="confetti-container"></div>

  <ng-container *ngIf="!isLoading && !errorMessage">
    <div class="success-icon">
      <div class="checkmark">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <div class="success-content">
      <h1 class="success-title">Congratulations!</h1>
      <p class="success-message">Your onboarding has been completed successfully</p>
      <p class="success-submessage">Welcome aboard! You're all set to get started.</p>
    </div>

    <div class="completion-badge">
      <div class="badge-icon">✓</div>
      <span>Setup Complete</span>
    </div>
  </ng-container>

  <div *ngIf="isLoading" class="loading-state">
    <div class="loading-spinner"></div>
    <p>Verifying your status...</p>
  </div>

  <div *ngIf="errorMessage && !isLoading" class="error-state">
    <div class="error-icon">⚠</div>
    <p>{{ errorMessage }}</p>
    <button (click)="retry()" class="retry-btn">Try Again</button>
  </div>
</div>